import request from "helper/request";

const adminClientApi = {
  // Upload company logo for a specific client (admin endpoint)
  uploadClientLogo: (clientId, formData) => {
    return request.post(`admin/clients/${clientId}/logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // Get company logo for a specific client (admin endpoint)
  getClientLogo: (clientId) => {
    return request.get(`admin/clients/${clientId}/logo`);
  }
};

export default adminClientApi;
